import {createBrowserHistory} from 'history'

// out side initialization of history for Router for use in outside of components
const browserHistory = createBrowserHistory()

export default browserHistory
